


















import { Vue, Component, Prop, Watch } from "vue-property-decorator";

import { GOOGLE_MAPS_API_KEY } from "@/utils/Constants";

declare global {
  interface Window {
    google?: any;
  }
}

export interface Point {
  lat: string;
  lng: string;
}

@Component
export default class VGooglePlaceAutocomplete extends Vue {
  @Prop({
    required: false,
    default: () => {
      return { country: "it", fields: ["ALL"] };
    },
  })
  readonly options: any;

  @Prop({ default: false }) readonly disabled?: boolean;
  @Prop({ default: false }) readonly required?: boolean;

  @Prop() readonly value!: string;
  @Prop() readonly placeAddress!: string;

  private placeAddressInput = "";

  private addressMetaData: any = [];

  @Watch("disabled")
  onDisabledChanged(val: boolean, newVal: boolean) {
    if (val && !newVal) {
      this.initialized();
    }
  }

  get id() {
    return `autocomplete_${(this as any)._uid}`;
  }

  get placeholder() {
    return this.disabled ? "-" : "Inserisci una posizione";
  }

  private autocomplete: any = null;
  private placesService: any = null;

  private place: any = null;
  private placeId: string | null = null;

  private cityAddress = "";

  @Watch("placeAddressInput")
  onPlaceAddressChange() {
    if (this.placeAddressInput) {
      this.placeId = null;

      this.cityAddress = this.placeAddressInput;
      this.getPlaceDetails();
    }
  }

  async initialized() {
    if (this.disabled) return;
    this.autocomplete = new window.google.maps.places.Autocomplete(
      this.$refs.input,
      this.options
    );
    this.autocomplete.addListener("place_changed", () => {
      this.onPlaceSelected(this.autocomplete.getPlace());
    });

    const map = new window.google.maps.Map(
      document.getElementById("map") as HTMLElement
    );
    this.placesService = new window.google.maps.places.PlacesService(map);

    if (this.placeAddressInput) {
      this.cityAddress = this.placeAddressInput;
      await this.getPlaceDetails(true);
    }
  }

  private async getPlaceDetails(init = false) {
    const service = new window.google.maps.places.AutocompleteService();

    const predictionsRequest = {
      input: this.cityAddress,
    };
    service.getPlacePredictions(
      predictionsRequest,
      (predictions: any, status: any) => {
        const prediction = predictions[0];

        // Retrieve the place by using the place_id.
        const placeRequest = {
          placeId: prediction.place_id,
          fields: ["name", "formatted_address", "place_id", "geometry"],
        };

        this.placesService.getDetails(
          placeRequest,
          (place: any, status: any) => {
            this.place = place;
            if (init) this.placeId = place.place_id;
          }
        );
      }
    );
  }

  onPlaceSelected(place: any) {
    this.cityAddress = place.formatted_address;
    this.addressMetaData = place.address_components;
    this.getPlaceDetails();
    this.place = place;
    this.placeId = this.place.place_id;
    this.$emit("selected", place);
  }

  get scriptUrl() {
    return `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places&language=it`;
  }

  async mounted() {
    this.placeAddressInput = this.placeAddress;

    if (!window.google) {
      let plugin = document.createElement("script");
      plugin.setAttribute("src", this.scriptUrl);
      plugin.async = true;
      document.head.appendChild(plugin);
      plugin.onload = async () => {
        await this.initialized();
      };
    } else {
      await this.initialized();
    }
    if (this.place) {
      this.placeId = this.place.place_id;
    }
  }

  getPlaceName(): string {
    return this.cityAddress;
  }

  getPlaceId(): string {
    if (this.placeId) return this.placeId;
    else return "";
  }

  getPlacePoint(): any {
    if (!this.place) {
      return { lat: "0", lng: "0" };
    }

    const lat = this.place.geometry.location.lat();
    const lng = this.place.geometry.location.lng();

    return { lat: lat, lng: lng };
  }

  getAddressMetaData() {
    return this.addressMetaData;
  }
}
